import styled from 'styled-components'

export const ContainerList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
